import {
    AccountControllerApi,
    AdGroupControllerApi,
    AdUnitControllerApi,
    AdvControllerApi,
    AgencyBalanceControllerApi,
    AgencyControllerApi,
    AuthLogReportControllerApi,
    BalanceControllerApi,
    CampaignControllerApi,
    CreativeControllerApi,
    CustomizationControllerApi,
    DealControllerApi,
    DictionariesControllerApi,
    DspControllerApi,
    FilterListControllerApi,
    FilterListGlobalControllerApi,
    InfoControllerApi,
    LogControllerApi,
    MandatoryFieldControllerApi,
    NbrStatApi,
    PublisherControllerApi,
    RegistrationControllerApi,
    ReportControllerApi,
    RetargetingListControllerApi,
    SavedReportControllerApi,
    SettingControllerApi,
    SspControllerApi,
    TrackerControllerApi,
    TrackerEventControllerApi,
} from './api'
import {configuration} from './BaseApi'
import {DirectApi} from './DirectApi'
import {callBackend} from './fetch'
import {LoginApi} from './LoginApi'

export const loginApi = new LoginApi()
export const directApi = new DirectApi()

export const agencyApi = new AgencyControllerApi(configuration, configuration.basePath, callBackend)
export const customizationApi = new CustomizationControllerApi(configuration, configuration.basePath, callBackend)
export const infoApi = new InfoControllerApi(configuration, configuration.basePath, callBackend)
export const advertiserApi = new AdvControllerApi(configuration, configuration.basePath, callBackend)
export const campaignApi = new CampaignControllerApi(configuration, configuration.basePath, callBackend)
export const adGroupApi = new AdGroupControllerApi(configuration, configuration.basePath, callBackend)
export const creativeApi = new CreativeControllerApi(configuration, configuration.basePath, callBackend)
export const registrationApi = new RegistrationControllerApi(configuration, configuration.basePath, callBackend)
export const reportApi = new ReportControllerApi(configuration, configuration.basePath, callBackend)
export const retargetingListApi = new RetargetingListControllerApi(configuration, configuration.basePath, callBackend)
export const dictionaryApi = new DictionariesControllerApi(configuration, configuration.basePath, callBackend)
export const filterListApi = new FilterListControllerApi(configuration, configuration.basePath, callBackend)
export const filterListGlobalApi = new FilterListGlobalControllerApi(configuration, configuration.basePath, callBackend)
export const trackerApi = new TrackerControllerApi(configuration, configuration.basePath, callBackend)
export const trackerEventApi = new TrackerEventControllerApi(configuration, configuration.basePath, callBackend)
export const accountApi = new AccountControllerApi(configuration, configuration.basePath, callBackend)
export const balanceApi = new BalanceControllerApi(configuration, configuration.basePath, callBackend)
export const agencyBalanceApi = new AgencyBalanceControllerApi(configuration, configuration.basePath, callBackend)
export const dspApi = new DspControllerApi(configuration, configuration.basePath, callBackend)
export const sspApi = new SspControllerApi(configuration, configuration.basePath, callBackend)
export const publisherApi = new PublisherControllerApi(configuration, configuration.basePath, callBackend)
export const adUnitApi = new AdUnitControllerApi(configuration, configuration.basePath, callBackend)
export const authLogApi = new AuthLogReportControllerApi(configuration, configuration.basePath, callBackend)
export const logApi = new LogControllerApi(configuration, configuration.basePath, callBackend)
export const mandatoryFieldApi = new MandatoryFieldControllerApi(configuration, configuration.basePath, callBackend)
export const settingApi = new SettingControllerApi(configuration, configuration.basePath, callBackend)
export const nbrStatApi = new NbrStatApi(configuration, configuration.basePath, callBackend)
export const savedReportApi = new SavedReportControllerApi(configuration, configuration.basePath, callBackend)
export const dealApi = new DealControllerApi(configuration, configuration.basePath, callBackend)
